/* Cubold cart drawer. Defines the <cart-drawer> element and keeps it in sync with the cart. */
(function () {
  if (customElements.get('cart-drawer')) return;

  var SECTION_ID = 'cg-cart-drawer';
  var RECS_SECTION = 'cg-cart-recs';
  var MAX_ANCHORS = 3;
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function announceCart(cart) {
    try {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer', cartData: cart });
      }
    } catch (e) {}
  }

  class CgCartDrawer extends HTMLElement {
    constructor() {
      super();
      this.activeElement = null;
      this.freshAt = 0;
      this.busy = false;
      this.recsToken = 0;
      this.recsCache = {};
    }

    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.freshAt = Date.now();
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      this.afterRender();
    }

    get panel() {
      return this.querySelector('.cg-cart__panel');
    }

    get content() {
      return this.querySelector('[data-cg-content]');
    }

    /* API used by the product form, quick add and the header icon */
    getSectionsToRender() {
      return [{ id: SECTION_ID }];
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    renderContents(parsedState) {
      var html = parsedState && parsedState.sections && parsedState.sections[SECTION_ID];
      if (html && this.applyHTML(html)) {
        this.open();
        return;
      }
      var self = this;
      this.refresh().then(function () {
        self.open();
      });
    }

    open(trigger) {
      if (trigger && trigger.nodeType === 1) this.activeElement = trigger;
      var self = this;
      this.classList.add('active');
      document.documentElement.classList.add('cg-cart-lock');
      setTimeout(function () {
        var panel = self.panel;
        if (panel && self.classList.contains('active')) panel.focus({ preventScroll: true });
      }, 60);
      if (Date.now() - this.freshAt > 1500) this.refresh();
    }

    close() {
      this.classList.remove('active');
      document.documentElement.classList.remove('cg-cart-lock');
      var target = this.activeElement;
      if (target && typeof target.focus === 'function' && document.contains(target)) {
        try {
          target.focus({ preventScroll: true });
        } catch (e) {}
      }
    }

    /* Fetch the drawer markup again and swap it in */
    refresh() {
      var self = this;
      var url = (window.routes && window.routes.root_url ? window.routes.root_url : '/') + '?section_id=' + SECTION_ID;
      return fetch(url, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (html) {
          if (html) self.applyHTML(html);
        })
        .catch(function (error) {
          console.warn('Cart drawer refresh failed', error);
        });
    }

    applyHTML(html) {
      var next = parseHTML(html).querySelector('[data-cg-content]');
      var current = this.content;
      if (!next || !current) return false;

      var scroller = this.querySelector('[data-cg-scroll]');
      var top = scroller ? scroller.scrollTop : 0;

      current.innerHTML = next.innerHTML;
      ['data-count', 'data-product-ids', 'data-anchor'].forEach(function (name) {
        current.setAttribute(name, next.getAttribute(name) || '');
      });
      current.classList.remove('is-loading');
      current.removeAttribute('aria-busy');

      var freshScroller = this.querySelector('[data-cg-scroll]');
      if (freshScroller) freshScroller.scrollTop = top;

      this.freshAt = Date.now();
      this.afterRender();
      return true;
    }

    afterRender() {
      this.refreshAffirm();
      this.loadRecommendations();
    }

    refreshAffirm() {
      try {
        if (window.affirm && window.affirm.ui && typeof window.affirm.ui.ready === 'function') {
          window.affirm.ui.ready(function () {
            window.affirm.ui.refresh();
          });
        }
      } catch (e) {}
    }

    setLoading(on) {
      var content = this.content;
      if (!content) return;
      content.classList.toggle('is-loading', on);
      if (on) content.setAttribute('aria-busy', 'true');
      else content.removeAttribute('aria-busy');
    }

    /* Manual pairings are rendered by Liquid from custom.cart_upsell.
       This tops the list up to four with Shopify recommendations for the items in the cart. */
    loadRecommendations() {
      var content = this.content;
      var holder = this.querySelector('[data-cg-upsell]');
      if (!content || !holder) return;

      var max = Number(this.getAttribute('data-max-recs')) || 4;
      var list = holder.querySelector('.cg-up__list');
      if (!list || list.children.length >= max) return;

      var seen = {};
      var anchors = (content.getAttribute('data-product-ids') || '')
        .split(',')
        .filter(function (id) {
          if (!id || seen[id]) return false;
          seen[id] = true;
          return true;
        })
        .slice(0, MAX_ANCHORS);
      if (!anchors.length) return;

      var self = this;
      var token = ++this.recsToken;
      var index = 0;

      function fill(html) {
        var currentList = self.querySelector('[data-cg-upsell] .cg-up__list');
        var currentHolder = self.querySelector('[data-cg-upsell]');
        var currentContent = self.content;
        if (!html || !currentList || !currentHolder || !currentContent) return;

        var inCart = (currentContent.getAttribute('data-product-ids') || '').split(',');
        var have = {};
        Array.prototype.forEach.call(currentList.children, function (li) {
          have[li.getAttribute('data-product-id')] = true;
        });

        Array.prototype.forEach.call(parseHTML(html).querySelectorAll('.cg-up__item'), function (li) {
          if (currentList.children.length >= max) return;
          var id = li.getAttribute('data-product-id');
          if (have[id] || inCart.indexOf(id) !== -1) return;
          have[id] = true;
          currentList.appendChild(document.importNode(li, true));
        });

        currentHolder.hidden = currentList.children.length === 0;
      }

      function load(anchor) {
        if (self.recsCache[anchor] !== undefined) return Promise.resolve(self.recsCache[anchor]);
        var url =
          '/recommendations/products?section_id=' + RECS_SECTION + '&product_id=' + encodeURIComponent(anchor) + '&limit=10&intent=related';
        return fetch(url, { headers: { Accept: 'text/html' }, credentials: 'same-origin' })
          .then(function (response) {
            return response.ok ? response.text() : '';
          })
          .then(function (html) {
            self.recsCache[anchor] = html;
            return html;
          });
      }

      function step() {
        if (token !== self.recsToken) return;
        var currentList = self.querySelector('[data-cg-upsell] .cg-up__list');
        if (!currentList || currentList.children.length >= max || index >= anchors.length) return;
        load(anchors[index++])
          .then(function (html) {
            if (token !== self.recsToken) return;
            fill(html);
            step();
          })
          .catch(function () {});
      }

      step();
    }

    /* Cart changes */
    changeLine(lineEl, quantity) {
      if (this.busy) return;
      this.busy = true;
      this.setLoading(true);
      var self = this;
      var errorEl = lineEl.querySelector('[data-cg-error]');
      if (errorEl) errorEl.hidden = true;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        credentials: 'same-origin',
        body: JSON.stringify({
          id: lineEl.getAttribute('data-key'),
          quantity: quantity,
          sections: SECTION_ID,
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || result.data.status) {
            self.setLoading(false);
            self.showLineError(lineEl, result.data.description || result.data.message);
            var input = lineEl.querySelector('[data-cg-input]');
            if (input) input.value = lineEl.getAttribute('data-qty');
            return;
          }
          announceCart(result.data);
          var html = result.data.sections && result.data.sections[SECTION_ID];
          if (html && self.applyHTML(html)) return;
          return self.refresh().then(function () {
            self.setLoading(false);
          });
        })
        .catch(function (error) {
          console.warn('Cart drawer update failed', error);
          self.setLoading(false);
        })
        .then(function () {
          self.busy = false;
        });
    }

    showLineError(lineEl, message) {
      var errorEl = lineEl.querySelector('[data-cg-error]');
      if (!errorEl) return;
      errorEl.textContent = message || 'That quantity is not available.';
      errorEl.hidden = false;
    }

    addVariant(variantId, button) {
      if (this.busy) return;
      this.busy = true;
      var self = this;
      var label = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: JSON_HEADERS,
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: SECTION_ID,
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || result.data.status) {
            if (button) {
              button.disabled = false;
              button.textContent = label;
            }
            return;
          }
          announceCart(result.data);
          var html = result.data.sections && result.data.sections[SECTION_ID];
          if (html && self.applyHTML(html)) return;
          return self.refresh();
        })
        .catch(function (error) {
          console.warn('Cart drawer add failed', error);
          if (button) {
            button.disabled = false;
            button.textContent = label;
          }
        })
        .then(function () {
          self.busy = false;
        });
    }

    /* Events */
    onClick(event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (target.closest('[data-cg-close]')) {
        event.preventDefault();
        this.close();
        return;
      }

      var step = target.closest('[data-cg-step]');
      if (step) {
        var stepLine = step.closest('.cg-line');
        if (!stepLine || step.disabled) return;
        var direction = Number(step.getAttribute('data-cg-step'));
        var increment = Number(stepLine.getAttribute('data-step')) || 1;
        var minimum = Number(stepLine.getAttribute('data-min')) || 1;
        var current = Number(stepLine.getAttribute('data-qty')) || 0;
        var next = current + direction * increment;
        if (next < minimum) next = 0;
        this.changeLine(stepLine, next);
        return;
      }

      var remove = target.closest('[data-cg-remove]');
      if (remove) {
        var removeLine = remove.closest('.cg-line');
        if (removeLine) this.changeLine(removeLine, 0);
        return;
      }

      var add = target.closest('[data-cg-add]');
      if (add && !add.disabled) {
        this.addVariant(add.getAttribute('data-cg-add'), add);
      }
    }

    onChange(event) {
      var input = event.target;
      if (!input || !input.matches || !input.matches('[data-cg-input]')) return;
      var line = input.closest('.cg-line');
      if (!line) return;

      var wanted = parseInt(input.value, 10);
      var current = Number(line.getAttribute('data-qty')) || 0;
      if (isNaN(wanted) || wanted < 0) {
        input.value = current;
        return;
      }
      var max = line.getAttribute('data-max');
      if (max !== '' && max !== null && wanted > Number(max)) {
        this.showLineError(line, 'Only ' + max + ' available.');
        input.value = current;
        return;
      }
      if (wanted !== current) this.changeLine(line, wanted);
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;

      var panel = this.panel;
      if (!panel) return;
      var focusable = Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) {
          return el.offsetParent !== null;
        }
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  customElements.define('cart-drawer', CgCartDrawer);
})();
